import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import init from './libs/init'
import * as ModalDialogs from 'vue-modal-dialogs'
import './libs/filters'
import Tooltip from './directives/tooltip'
import AutoFitText from './directives/autoFitText'

import VueGtag from 'vue-gtag'

Vue.config.productionTip = false
Vue.use(ModalDialogs)
Vue.use(Tooltip, {
  maxWidth: 300,
  theme: 'light',
})
Vue.use(AutoFitText)

Vue.use(VueGtag, {
  config: {
    id: 'AW-835556530'
  }
})

if (['reboot.beusable.net', 'tool.beusable.net'].indexOf(location.hostname) !== -1) {
  if (console && console.log) {
    console.log = () => {}
    console.error = () => {}
  }
}

init().then(i18n => {
  window.__VUE_ROOT__ = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})
